import _ from 'lodash';

export function formatPercentage(val) {
  if (val >= 100) return '100';
  if (val < 100 && val > 0) return val.replace(/[^0-9]/g, '');
  return '';
}
export function formatOnlyNumber(val) {
  const value = val.slice(0, 12);
  return {
    numberRequest: value.replace(/[^0-9]/g, ''),
    countNumberRequest: value.length,
  };
}
export function formatNumberRequest(val) {
  return val.padStart(12, '0');
}
export function rutRemoveFormat(rut) {
  return String(rut).toUpperCase().replace(/[. ,-]+/g, '');
}
export function rutRemoveFormatByParts(rut) {
  const rutNoFormat = rutRemoveFormat(rut);
  const dv = rutNoFormat.charAt(rutNoFormat.length - 1);
  const justRut = rutNoFormat.substring(0, rutNoFormat.length - 1);
  return {
    Rut: justRut !== '' ? parseInt(justRut, 10) : 0,
    Dv: dv.toString(),
  };
}

export function serialNumberFormat(value, symbol = 'A') {
  const startA = _.startsWith(value, symbol);
  const replace = startA ? '' : '.';
  const limit = !startA ? 11 : 10;
  let serialNumberReset = value.slice(0, limit);
  serialNumberReset = serialNumberReset.toString().replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, replace);
  if (!startA || !value) {
    return `${serialNumberReset}`;
  }
  return `${symbol}${serialNumberReset}`;
}

export function serialNumberFormatRead(value) {
  if (value.length === 9) { return `${value.substring(0, 3)}.${value.substring(3, 6)}.${value.substring(6, 9)}`; }

  return value;
}

export function accountNumberFormat(value) {
  const limit = 15;
  let serialNumberReset = value.slice(0, limit);
  serialNumberReset = serialNumberReset.replace(/[^0-9]/g, '');
  return `${serialNumberReset}`;
}
export function moneyRemoveFormat(money, symbol = '$') {
  return money ? parseFloat(money.toString().replace(/ /g, '').replace(symbol, '').replace(/\./g, '')
    .replace(',', '.')) : 0;
}
export function moneyFormat(value, symbol = '$') {
  // para formatear tipo $ no lleva decimales
  const val = moneyRemoveFormat(value, symbol);
  const moneyReset = val.toString().replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  return `${symbol} ${moneyReset}`;
}

export function valueFormat(value, symbol = '$') {
  return moneyFormat(value, symbol);
}

export function rutFormat(rut) {
  let sRut = rutRemoveFormat(rut);
  let sRutFormateado = '';

  const sDV = sRut.charAt(sRut.length - 1); // digito verificador
  sRut = sRut.substring(0, sRut.length - 1); // el resto del numero

  while (sRut.length > 3) {
    sRutFormateado = `.${sRut.substr(sRut.length - 3)}${sRutFormateado}`;
    sRut = sRut.substring(0, sRut.length - 3);
  }

  sRutFormateado = sRut + sRutFormateado;

  if (sRutFormateado) {
    sRutFormateado += `-${sDV}`;
    return sRutFormateado;
  }

  return sRutFormateado;
}

export function capitalize(str, lower = false) {
  return (lower ? str.toLowerCase() : str).replace(/(?:^|\s|["'([{])+\S/g, match => match.toUpperCase());
}
